import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';

export const templateCompanyMspInProductTrialsTab = document.createElement('template');

templateCompanyMspInProductTrialsTab.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class="products-section d-flex" id="trialCards"></div>
    <gz-msp-landing-page id='msp-in-product-trials-landing-page'></gz-msp-landing-page>
  </div>
`;
